import React from 'react';

import * as S from './styles';
import { promptSuggestion } from './contants';
import Chat from 'v2/components/Chat';
import Icon from 'v2/components/Icon';
import ModalCommandSuggestions from '../components/ModalCommandSuggestions';
import useGreenfyAI from './hooks/useGreenfyAI';
import ModalMostUsedCommand from '../components/ModalMostUsedCommand';
import ModalGreenfyWhatCanYouDo from '../components/ModalGreenfyWhatCanYouDo';
import Menu from './components/Menu';

const GreenfyIA: React.FC = () => {
  const {
    showModalCommandSuggestions,
    showModalCommandMostUsed,
    stepCurrent,
    prompt,
    showModalGreenfyWhatCanYouDo,
    paddingLeft,

    handleShowModal,
    handleSetPrompt,
    handleStepCurrent,
    handleShowModalGreenfyWhatCanYouDo,
  } = useGreenfyAI();

  return (
    <S.Container paddingLeft={paddingLeft}>
      <Menu />

      <S.WrapperContent>
        <S.Content>
          <S.WrapperTitle>
            <S.IconAi />
            <S.Title>Greenfy A.I</S.Title>
          </S.WrapperTitle>
          <S.WrapperSuggestions>
            <S.TitleSuggestions>Guia de uso</S.TitleSuggestions>

            <S.WrapperCardsSuggestions>
              {promptSuggestion.map((item) => (
                <S.CardsSuggestions
                  key={item.id}
                  onClick={() => handleShowModal(item.id)}
                >
                  <Icon
                    iconName={item.iconName}
                    fontSize="medium"
                    htmlColor="#005F47"
                  />
                  <S.TitleCardsSuggestions>
                    {item.title}
                  </S.TitleCardsSuggestions>
                </S.CardsSuggestions>
              ))}
            </S.WrapperCardsSuggestions>
          </S.WrapperSuggestions>
          <Chat promptParam={prompt} />
        </S.Content>
      </S.WrapperContent>

      <ModalCommandSuggestions
        isOpen={showModalCommandSuggestions}
        stepCurrent={stepCurrent}
        onBack={handleShowModal}
        onClose={handleShowModal}
        setPrompt={handleSetPrompt}
        setStepCurrent={handleStepCurrent}
      />

      <ModalMostUsedCommand
        isOpen={showModalCommandMostUsed}
        onBack={handleShowModal}
        onClose={handleShowModal}
        setPrompt={handleSetPrompt}
      />
      <ModalGreenfyWhatCanYouDo
        isOpen={showModalGreenfyWhatCanYouDo}
        onBack={handleShowModalGreenfyWhatCanYouDo}
        onClose={handleShowModalGreenfyWhatCanYouDo}
      />
    </S.Container>
  );
};
export default GreenfyIA;
